import React from 'react';

export const DataTableBodyCellRecordFieldEditableLabel = ({ fieldLabel }) => {
  return <React.Fragment>{fieldLabel}</React.Fragment>;
};

export default DataTableBodyCellRecordFieldEditableLabel;
